import React from 'react'
import { Link as LinkPage} from 'react-router-dom'
import "./notFound.css";

import logo from "../../assets/images/logo2/ponos-logo-mark-blue-original.svg";

function NotFound() {
  return (
     <section className='notFound_section'>
       
      <div className='container notFound_main'>

        <header className='notFound_header'>
               <LinkPage className='notFound-logo-wrapper' to={'/'}>
       <img className="notFound-logo-img" src={logo} alt="ponos-logo-mark" />
    
      </LinkPage>  

  
        </header>
        <div className='notFound_text_wrapper'>

          <h1>404 error</h1>
          <h2 className='notFound_first'>The page you’re looking for</h2>
          <h2 className='notFound_second'>is not found or doesn’t exist</h2>
          

         <LinkPage to={'/'} className='notFound_btn no-wrap'>
                     <span>Go to homepage</span>
        </LinkPage>  

        </div>

      </div>
      

    </section>
  )
}

export default NotFound
